// third-party
import { FormattedMessage } from 'react-intl';

// assets
import IconHome from 'assets/applebox/Icon_Home_Line.png';
import IconGame from 'assets/applebox/Icon_Game_Line.png';
import IconWallet from 'assets/applebox/Icon_Wallet_Line.png';
import IconMypage from 'assets/applebox/Icon_Mypage_Line.png';
import IconLogout from 'assets/applebox/Icon_Logout_Line.png';

const menulist = {
    id: 'fulllist',
    title: <FormattedMessage id="fulllist" />,
    iconfile : IconHome,
    type: 'group',
    children: [
        {
            id: 'home',
            title: <FormattedMessage id="home" />,
            type: 'item',
            url: '/',
            iconfile : IconHome,
            breadcrumbs: false
        },
        {
            id: 'game',
            title: <FormattedMessage id="Game" />,
            type: 'collapse',
            iconfile : IconGame,
            children: [
                {
                    id: 'bitball',
                    title: <FormattedMessage id="BitBall" />,
                    type: 'item',
                    iconfile : IconGame,
                    url: '/game/bitball',
                    breadcrumbs: false
                },
                {
                    id: 'powerball',
                    title: <FormattedMessage id="PowerBall" />,
                    type: 'item',
                    iconfile : IconGame,
                    url: '/game/powerball',
                    breadcrumbs: false
                },
                {
                    id: 'lottery',
                    title: <FormattedMessage id="Lottery" />,
                    type: 'item',
                    iconfile : IconGame,
                    url: '/game/lottery',
                    breadcrumbs: false
                },
            ]
        },
        {
            id: 'wallet',
            title: <FormattedMessage id="Wallet" />,
            type: 'item',
            url: '/wallet',
            iconfile : IconWallet,
            breadcrumbs: false
        },
        {
            id: 'mypage',
            title: <FormattedMessage id="Mypage" />,
            type: 'item',
            url: '/mypage',
            iconfile : IconMypage,
            breadcrumbs: false
        },
        {
            id: 'logout',
            title: <FormattedMessage id="Log Out" />,
            type: 'item',
            url: '/logout',
            iconfile : IconLogout,
            breadcrumbs: false
        }
    ]
};

export default menulist;
